import { Components, Theme } from '@mui/material';
import { dark, grey } from './themeColors';

// ========================================================
declare module '@mui/material/Button' {
    interface ButtonPropsColorOverrides {
        dark: true;
        paste: true;
        marron: true;
    }

    interface ButtonPropsSizeOverrides {
        normal: true;
    }
}
// =========================================================

const nanumSquareL = {
    fontFamily: 'NanumSquare',
    fontStyle: 'lighter',
    fontWeight: 100,
    src: `url('/static/fonts/NanumSquareOTF_acL.otf') format('opentype'), url('/static/fonts/NanumSquareL.woff') format('woff')`
};

const nanumSquareR = {
    fontFamily: 'NanumSquare',
    fontStyle: 'normal',
    fontWeight: 400,
    src: `url('/static/fonts/NanumSquareOTF_acR.otf') format('opentype'), url('/static/fonts/NanumSquareR.woff') format('woff')`
};

const nanumSquareB = {
    fontFamily: 'NanumSquare',
    fontStyle: 'bold',
    fontWeight: 700,
    src: `url('/static/fonts/NanumSquareOTF_acB.otf') format('opentype'), url('/static/fonts/NanumSquareB.woff') format('woff')`
};

const nanumSquareEB = {
    fontFamily: 'NanumSquare',
    fontStyle: 'bolder',
    fontWeight: 800,
    src: `url('/static/fonts/NanumSquareOTF_acEB.otf') format('opentype'), url('/static/fonts/NanumSquareEB.woff') format('woff')`
};

const dDinR = {
    fontFamily: 'D-DIN',
    fontStyle: 'normal',
    fontWeight: 400,
    src: `url('/static/fonts/D-DIN.otf') format('opentype'), url('/static/fonts/D-DIN.woff') format('woff')`
};

const dDinB = {
    fontFamily: 'DIN-Bold',
    fontStyle: 'normal',
    fontWeight: 800,
    src: `url('/static/fonts/D-DIN-Bold.otf') format('opentype'), url('/static/fonts/D-DIN-Bold.woff') format('woff')`
};

export const components: Components = {
    MuiCssBaseline: {
        styleOverrides: (theme: Theme) => ({
            html: [
                { scrollBehavior: 'smooth' },
                { '@font-face': nanumSquareL },
                { '@font-face': nanumSquareR },
                { '@font-face': nanumSquareB },
                { '@font-face': nanumSquareEB },
                { '@font-face': dDinR },
                { '@font-face': dDinB }
            ],
            p: { lineHeight: 1.75 },
            button: {
                fontSize: 14,
                fontFamily: 'NanumSquare'
            },
            '.MuiRating-sizeSmall': {
                fontSize: '20px'
            },
            a: {
                textDecoration: 'none',
                color: 'inherit'
            },
            ul: {
                margin: 0,
                padding: 0,
                listStyle: 'none'
            },
            '#nprogress .bar': {
                overflow: 'hidden',
                height: '3px !important',
                zIndex: '99999999 !important',
                background: `${theme.palette.primary.main} !important`
            }
        })
    },
    MuiInputLabel: {
        styleOverrides: {
            root: { zIndex: 0 }
        }
    },
    MuiDialog: {
        styleOverrides: {
            paper: { borderRadius: 8 }
        }
    },
    MuiCard: {
        styleOverrides: {
            root: { borderRadius: '8px' }
        }
    },
    MuiPagination: {
        defaultProps: {
            variant: 'outlined',
            color: 'primary'
        }
    },
    MuiMenuItem: {
        styleOverrides: {
            root: { paddingTop: 8, paddingBottom: 8 }
        }
    },
    MuiSvgIcon: {
        styleOverrides: {
            root: {
                '& .secondary': { opacity: 0.4 }
            }
        }
    },
    MuiTextField: {
        defaultProps: { size: 'small', variant: 'outlined' },
        styleOverrides: {
            root: ({ ownerState }) => ({
                ...(ownerState.color === 'info' && {
                    '& .MuiOutlinedInput-root': { borderRadius: '8px', fontWeight: 600 },
                    '& .MuiOutlinedInput-notchedOutline': { borderColor: grey[300] }
                })
            })
        }
    },

    MuiButton: {
        styleOverrides: {
            root: ({ ownerState }) => ({
                minWidth: 0,
                minHeight: 0,
                fontWeight: 600,
                textTransform: 'capitalize',
                ...(ownerState.color === 'info' && { borderRadius: '8px' }),
                ...(ownerState.color === 'dark' && {
                    color: '#fff',
                    borderRadius: 0,
                    transition: 'all 0.3s',
                    ':hover': { backgroundColor: '#343434' }
                }),
                ...(ownerState.color === 'dark' &&
                    ownerState.variant === 'outlined' && {
                        color: dark.main,
                        borderRadius: '3px',
                        transition: 'all 0.3s',
                        ':hover': { backgroundColor: dark.main, color: 'white' }
                    })
            }),
            sizeLarge: { padding: '.6rem 2.5rem' }
        },
        defaultProps: { color: 'inherit' }
    }
};
